<template>
  <figure class="image" :class="dimension">
    <img :src="src" :class="{ 'is-rounded': rounded }" />
  </figure>
</template>

<script>
import axios from "axios";
export default {
  name: "ImageBox",
  props: {
    url: {
      type: String,
      required: true
    },
    dimension: {
      type: String,
      required: false,
      default: "is-16x16"
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      src: ""
    };
  },
  mounted() {
    axios.get(this.url, { responseType: "arraybuffer" }).then(
      r => {
        let b64 = new Buffer(r.data, "binary").toString("base64");
        this.src = `data:${r.headers["content-type"]};base64,` + b64;
      },
      err => {
        console.log(err);
      }
    );
  }
};
</script>
